import { Alert, Button, Textarea, TextInput } from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons"
import { Dispatch, SetStateAction, useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import AuthenticationContext from "../AuthenticationContext"

const sendNotification = (
  token: string,
  title: string,
  content: string,
  setError: Dispatch<SetStateAction<boolean>>,
  setLoading: Dispatch<SetStateAction<boolean>>
) => {
  setLoading(true)

  fetch("https://resinglass-api.igloo.ooo/admin/notification", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: `{"title":"${title}","content":"${content}"}`,
  })
    .then(({ ok }) => {
      if (!ok) setError(true)
    })
    .catch(() => setError(true))
    .finally(() => setLoading(false))
}

const Notifications = () => {
  const [token] = useContext(AuthenticationContext)
  const { t } = useTranslation()

  const [title, setTitle] = useState<string>("")
  const [content, setContent] = useState<string>("")
  const [error, setError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <div
      style={{
        margin: "24px auto",
        maxWidth: "600px",
        width: "calc(100% - 64px)",
      }}
    >
      <Alert
        icon={<IconAlertCircle />}
        color="red"
        style={{ marginBottom: "24px" }}
      >
        {t`Le condizioni dell'Apple Developer Program impongono di non utilizzare il servizio di notifiche per l'invio di messaggi promozionali senza aver raccolto il consenso degli utenti, si chiede dunque di limitarsi ad inviare comunicazioni di servizio pena il bando dall'Apple App Store`}
      </Alert>
      <TextInput
        value={title}
        onChange={(event) => {
          setTitle(event.target.value)
          setError(false)
        }}
        onKeyDown={({ code }) => {
          if (code === "Enter") {
            sendNotification(token, title, content, setError, setLoading)
          }
        }}
        label={t`Titolo` as String}
        size="md"
        error={error}
        style={{}}
      />
      <Textarea
        value={content}
        onChange={(event) => {
          setContent(event.target.value)
          setError(false)
        }}
        onKeyDown={({ code }) => {
          if (code === "Enter") {
            sendNotification(token, title, content, setError, setLoading)
          }
        }}
        label={t`Contenuto` as String}
        error={error ? t`Error` : null}
        size="md"
        style={{
          margin: "24px 0 12px",
          paddingBottom: error ? 0 : "21px",
        }}
        autosize
        minRows={4}
      />
      <Button
        size="md"
        fullWidth
        disabled={!title || !content}
        onClick={() =>
          sendNotification(token, title, content, setError, setLoading)
        }
        loading={loading}
      >{t`Invia`}</Button>
    </div>
  )
}

export default Notifications
